/* eslint-disable max-depth */
/* eslint-disable complexity */
import {
  RelayNetworkLayerResponse,
  Middleware,
  FetchOpts,
  RelayNetworkLayerRequest,
} from 'react-relay-network-modern';

type persistedQueriesMapGetter = () => Promise<Record<string, string>>;

export type MinificationMiddlewareOpts = {
  minification?: boolean;
  getPersistedQueriesMap?: persistedQueriesMapGetter;
};

export default function minificationMiddleware(options: MinificationMiddlewareOpts): Middleware {
  return next => async req => {
    if (!(req instanceof RelayNetworkLayerRequest)) {
      return next(req);
    }
    const { operation, fetchOpts, variables } = req;
    if (operation.operationKind === 'query' && options.minification) {
      const originalFetchOps = { ...fetchOpts };
      req.fetchOpts = _handleMinificationFetchOpts({ fetchOpts, variables, operation });
      try {
        return await next(req);
      } catch (e) {
        // TODO: Handle a specific error here(Persisted Query not found), not all errors
        if (options.getPersistedQueriesMap) {
          const response = await _refetchWithPOSTFromServer(originalFetchOps, {
            getPersistedQueriesMap: options.getPersistedQueriesMap,
          });
          if (response) {
            return RelayNetworkLayerResponse.createFromFetch(response);
          }
        }
        throw e;
      }
    }
    return next(req);
  };
}

function _handleMinificationFetchOpts({
  fetchOpts,
  operation,
  variables,
}: {
  fetchOpts: FetchOpts;
  operation: { id: string | null; name: string };
  variables: any;
}) {
  if (!fetchOpts.url) {
    throw new Error('Server url not present!');
  }
  const queryHash = operation.id;
  const url = new URL(fetchOpts.url);
  const searchParams = {
    queryHash,
    variables: JSON.stringify(variables),
    operationName: operation.name,
  };
  Object.entries(searchParams).map(([name, value]) => url.searchParams.append(name, value || ''));
  fetchOpts.method = 'GET';
  fetchOpts.url = url.toString();
  // delete fetchOpts.body;
  return fetchOpts;
}

async function _refetchWithPOSTFromServer(
  fetchOpts: FetchOpts,
  { getPersistedQueriesMap }: { getPersistedQueriesMap: persistedQueriesMapGetter }
) {
  if (!(typeof fetchOpts.body === 'string')) {
    return;
  }
  if (!fetchOpts.url) {
    throw new Error('Server url not present!');
  }
  const persistedQueries = await getPersistedQueriesMap();
  const body = JSON.parse(fetchOpts.body);
  body.query = persistedQueries[body.id];
  fetchOpts.body = JSON.stringify(body);
  return fetch(fetchOpts.url, {
    body: fetchOpts.body,
    method: fetchOpts.method,
    headers: fetchOpts.headers,
  });
}
